import { PROMOS } from './promo';

/** Hauteur réservée pour la bannière promo (px), alignée avec Navigation sticky offset. */
export const PROMO_BANNER_OFFSET_PX = 40;

/** Script inline exécuté dans <head> avant le paint pour éviter le layout shift au reload. */
export function getPromoActiveInlineScript(): string {
  const promosJson = JSON.stringify(
    PROMOS.map(({ startDate, endDate }) => ({ startDate, endDate })),
  );

  return `(function(){var ps=${promosJson};function a(){var n=new Date();return ps.some(function(p){if(!p.startDate||!p.endDate)return false;var s=new Date(p.startDate),e=new Date(p.endDate);return!isNaN(s.getTime())&&!isNaN(e.getTime())&&n>=s&&n<=e;});}if(a())document.documentElement.setAttribute("data-promo-active","true");})();`;
}
